export default __webpack_public_path__ + "static/media/photo_5282747746622312891_y.6cdd4992.jpg";